import { useEffect, useState } from 'react'
import { userData } from '@signals'
import { executionsApi } from 'Pages/DsRepricing/Executions/@services/api'
import { shouldAsk } from 'Pages/RealTimeHistory/RealTime/@services/enginePass'

/**
 * `{ execution_id, slot }` of the pass that launched this search, or null.
 * One call per search, only with DS Repricing (decision A); any failure is
 * silent — the mark is extra, the results are what the page is for, and
 * the status/results path is not touched (UX Obs. 7).
 */
export default function useEnginePass(idSearch) {
	const [pass, setPass] = useState(null)
	const featuresV2 = userData.value?.featuresV2
	const ask = shouldAsk(idSearch, featuresV2)
	useEffect(() => {
		setPass(null)
		if (!ask) return undefined
		let alive = true
		executionsApi.passOfSearch(idSearch)
			.then(body => { if (alive) setPass(body?.pass || null) })
			.catch(() => { /* no mark */ })
		return () => { alive = false }
	}, [idSearch, ask])
	return pass
}
